<template>
    <div class="chapter-tip">
        <div class="chapter-tip-title f18 font-MT f-fwb">
            <slot name="tip-name">
            </slot>
        </div>
        <div class="chapter-tip-con f16 font-PF-R text-fff">
            <slot name="tip-con">
                Ever since Yvonne Frey married Henry Lancaster, she alone stayed in an empty house for three years.
                Just when she was on the verge of giving up, this man suddenly came back and said that he wanted to live together with her!
                “Mr. Lancaster… Should I prepare a guest room for you?”“What?
                So I’m only a guest to you?!” Henry gritted his teeth. Now, who was the dismissive one here? Free online website novels & books for fiction loves.
                Popular web novels with massive original English stories, types include urban, romance,
                fantasy, werewolf, classic and so on.
                For more high-quality content and experience, you can download the Webfic official app
                and enjoy the fun of reading together.
                Download it now and enjoy reading together.
            </slot>
        </div>
        <div class="chapter-tip-btn">
            <slot name="tip-btn">
                <el-button class="f16 font-MT" type="info" size="medium">Application</el-button>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style lang="scss" scoped>
    .chapter-tip{
        margin: 0 50px;
    }
    .chapter-tip-title{
        color: #fff;
        height: 70px;
        border-bottom: 1px solid #575776;
        line-height: 70px;
    }
    .chapter-tip-con{
        margin-top: 25px;
        line-height: 36px;
    }
    .chapter-tip-btn{
       margin-top: 62px;
        padding: 12px 3px;
    }
</style>
